import React from "react";
import roleEditIcon from "../../../../../../assets/edit.png";
import { OrganizationType } from "../Users/types/OrganizationType";
import { useStore } from "../../../../../../Hooks/useStore";
import Organization from "./Organization";
import "./Organization.css"

interface EditIconProps {
  user: OrganizationType;
}

const EditIcon: React.FC<EditIconProps> = ({ user }) => {
    const {rootStore}=useStore();
    const OpenEditRoleBar =() =>{
        // rootStore.adminStore.handleEditRoles(true);
    }
  // You can use the 'user' prop here to customize the behavior or appearance of the icon if needed
  return (
    <div className="edit-icon">
      <img className="edit-icon-img"
      src={roleEditIcon} alt="Edit Icon" onClick={OpenEditRoleBar} />
    </div>
  );
};

export default EditIcon;
